


import claimService from '../services/claimService';

export const CLEAR_TOAST_MESSAGE_NOTIFICATION = '@member/clear-toast-notification-message';
export const UPDATE_MEMBER = '@member/update-member';
export const GET_LIST_COUNTRY_STATES = '@account/country-states';
export const GET_ECP_CATEGORIES = '@account/ecp-category';
export const ADD_CLAIM = '@account/add-claim';
export const UPDATE_CLAIM = '@account/update-claim';
export const GET_CLAIMS = '@account/get-claim';
export const SET_DEALER_INFO = '@account/set-dealer-info';
export const SET_ORDER_INFO = '@account/set-order-info';
export const SET_CLAIM_INFO = '@account/set-claim-info';

export function saveClaim(claim) {
  const request = claimService.updateClaim(claim);

  return (dispatch) => {
    request.then((response) => dispatch({
      type: UPDATE_CLAIM,
      payload: response.data
    }));
  };
}

export function setOrderInfo(orderInfo) {
  return async (dispatch) => {

    dispatch({
      type: SET_ORDER_INFO,
      payload: { ...orderInfo }
    });

  };
}

export function setClaimInfo(claimInfo) {
  return async (dispatch) => {

    dispatch({
      type: SET_CLAIM_INFO,
      payload: { ...claimInfo }
    });

  };
}

export function setDealerInfo(dealerInfo) {
  return async (dispatch) => {

    const result = await claimService.listOfCountryStates();
    dispatch({
      type: SET_DEALER_INFO,
      payload: { ...dealerInfo }
    });

  };
}

export function getListOfCountryStates() {
  return async (dispatch) => {

    const result = await claimService.listOfCountryStates();
    dispatch({
      type: GET_LIST_COUNTRY_STATES,
      payload: { ...result }
    });

  };
}

export function getEcpCategories() {
  return async (dispatch) => {
    const result = await claimService.getEcpCategories();
    dispatch({
      type: GET_ECP_CATEGORIES,
      payload: { ...result }
    });
  };
}

export function updateMember(member) {

  return async (dispatch) => {

    dispatch({
      type: UPDATE_MEMBER,
      payload: { ...member }
    });

  };
}

export function clearToastNotificationMessage() {

  return async (dispatch) => {
    dispatch({
      type: CLEAR_TOAST_MESSAGE_NOTIFICATION,
      payload: null
    });
  };
}